import { createSlice } from "@reduxjs/toolkit";

import { fetchClientDetailsData } from "../thunks/clientFormUpdateThunk";

import type { clientDetails } from "../../utils/types/type-helper";

interface ClientDetailsState {
  clientUpdateDetails: clientDetails | null;
  loading: boolean;
  error: string | null;
  success: boolean;
}

const initialState: ClientDetailsState = {
  clientUpdateDetails: null,
  loading: false,
  success: false,
  error: null,
};

export const clientDetailsSlice = createSlice({
  name: "clientUpdateDetails",
  initialState,
  reducers: {
    resetSuccess: (state) => {
      state.success = false;
    },
    resetClientStore: (state) => {
      state.clientUpdateDetails = null;
      state.loading = false;
      state.success = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClientDetailsData.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(fetchClientDetailsData.fulfilled, (state, action) => {
        state.clientUpdateDetails = action.payload;
        state.loading = false;
        state.success = true;
      })
      .addCase(fetchClientDetailsData.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
        state.success = false;
      });
  },
});
export const { resetClientStore } = clientDetailsSlice.actions;

export default clientDetailsSlice.reducer;
